import { render, staticRenderFns } from "./Activitydetail.vue?vue&type=template&id=2d81b78c&scoped=true&"
import script from "./Activitydetail.vue?vue&type=script&lang=js&"
export * from "./Activitydetail.vue?vue&type=script&lang=js&"
import style0 from "./Activitydetail.vue?vue&type=style&index=0&id=2d81b78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81b78c",
  null
  
)

export default component.exports